#import "../fragments/user-quota-fragment.graphql"

mutation QuotaCreate($input: QuotaCreateInput!) {
    quotaCreate(input: $input) {
        users {
            ...UserQuotaFragment
        }
    }
}
